var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id },
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c(
            "a",
            {
              staticClass: "thumb-image-inner",
              class: {
                "stretched-link":
                  _vm.$ceres.config.global.shippingCostsCategoryId == 0,
              },
              attrs: {
                href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
              },
            },
            [
              _c("div", { staticClass: "thumb-image" }, [
                _c(
                  "div",
                  { staticClass: "prop-1-1 cimage" },
                  [
                    _vm._t("item-image", function () {
                      return [
                        _vm.preloadImage
                          ? _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: _vm.singleImage.url + ".avif",
                                alt: _vm._f("itemName")(_vm.item),
                                width: _vm.singleImage.width,
                                height: _vm.singleImage.height,
                                fetchpriority: "high",
                              },
                            })
                          : _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: _vm.singleImage.url + ".avif",
                                alt: _vm._f("itemName")(_vm.item),
                                width: _vm.singleImage.width,
                                height: _vm.singleImage.height,
                                loading: "lazy",
                                decoding: "async",
                              },
                            }),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._t("store-special", function () {
            return [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType,
                    },
                  })
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm._t("item-details", function () {
            return [
              _c(
                "div",
                { staticClass: "thumb-content" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "thumb-title small",
                      class: {
                        "stretched-link":
                          _vm.$ceres.config.global.shippingCostsCategoryId == 0,
                      },
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("itemName")(_vm.item)) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isBook
                    ? _c("div", { staticClass: "item-details__book-details" }, [
                        _vm.item.texts.name3
                          ? _c(
                              "span",
                              { staticClass: "item-details__subtitle" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.item.texts.name3) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.texts.name2
                          ? _c(
                              "span",
                              { staticClass: "item-details__author" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.item.texts.name2) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.texts.shortDescription
                          ? _c("span", { staticClass: "item-details__short" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.item.texts.shortDescription) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "thumb-meta mt-2" },
                    [_vm._t("before-prices")],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("after-prices"),
                  _vm._v(" "),
                  _vm.isBook
                    ? _c("div", { staticClass: "item-details__book-btn" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-appearance item-details__showItem",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.directToItem()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$translate("Ceres::Template.itemShowItem")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }